import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import * as React from 'react';
import ReactDOM from 'react-dom';
import { StyleBaseline } from '@alinta-digital/asg';
import { App } from './App';
import GlobalStyle from './GlobalStyle';
import * as serviceWorker from './serviceWorker';

// If existing window.AlintaGlobals is required....
// (window as any).AlintaGlobals = alintaGlobalsConfig.config;

ReactDOM.render(
  <>
    <StyleBaseline />
    <GlobalStyle />
    <App />
  </>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
